import { render, staticRenderFns } from "./GradesInput.vue?vue&type=template&id=af2bc95c&scoped=true"
import script from "./GradesInput.vue?vue&type=script&lang=js"
export * from "./GradesInput.vue?vue&type=script&lang=js"
import style0 from "./GradesInput.vue?vue&type=style&index=0&id=af2bc95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2bc95c",
  null
  
)

export default component.exports